export default __webpack_public_path__ + "2f022931f0d2dcc3e55c2ef5fd453f03.svg";